import CryptoJS from "crypto-js";

const secretKey =
  process.env.REACT_APP_SECRET_KEY || "!@#$%%^&&seasense)(*&^&^%^";

// ......................................Token...................................................

export const storeUserToken = (data) => {
  try {
    const encryptedData = CryptoJS.AES.encrypt(data, secretKey).toString();
    localStorage.setItem("token", encryptedData);
  } catch (error) {}
};
export const getUserToken = () => {
  try {
    const encryptedData = localStorage.getItem("token");
    if (!encryptedData) return null;

    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData || null;
  } catch (error) {
    return null;
  }
};

// ......................................User Details...................................................

export const storeUserDetails = (data) => {
  try {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      secretKey
    ).toString();
    localStorage.setItem("user", encryptedData);
  } catch (error) {}
};

export const getUserDetails = () => {
  try {
    const encryptedData = localStorage.getItem("user");
    if (!encryptedData) return null;

    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (decryptedData) {
      return JSON.parse(decryptedData);
    }
    return null;
  } catch (error) {
    return null;
  }
};

// ......................................Company Details...................................................

export const storeCompanyDetails = (data) => {
  try {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      secretKey
    ).toString();
    localStorage.setItem("company", encryptedData);
  } catch (error) {}
};

export const getCompanyDetails = () => {
  try {
    const encryptedData = localStorage.getItem("company");
    if (!encryptedData) return null;

    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    if (decryptedData) {
      return JSON.parse(decryptedData);
    }
    return null;
  } catch (error) {
    return null;
  }
};

//................................................Selected Company................................

export const storeSelectedCompany = (data) => {
  try {
    const dataString = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    localStorage.setItem("selectedcomp", encryptedData);
  } catch (error) {}
};

export const getSelectedCompany = () => {
  try {
    const encryptedData = localStorage.getItem("selectedcomp");
    if (!encryptedData) return null;
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (decryptedData) {
      return JSON.parse(decryptedData);
    }
    return null;
  } catch (error) {
    return null;
  }
};

//........................................Selected user..........

export const storeSelectedPerson = (data) => {
  try {
    const dataString = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    localStorage.setItem("selectedperson", encryptedData);
  } catch (error) {}
};

export const getSelectedPerson = () => {
  try {
    const encryptedData = localStorage.getItem("selectedperson");
    if (!encryptedData) return null;
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (decryptedData) {
      return JSON.parse(decryptedData);
    }
    return null;
  } catch (error) {
    return null;
  }
};

//............................................Selected User Dms..................

export const storeSelectedDms = (data) => {
  try {
    const dataString = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    localStorage.setItem("seleteddms", encryptedData);
  } catch (error) {}
};

export const getSelectedDms = () => {
  try {
    const encryptedData = localStorage.getItem("seleteddms");
    if (!encryptedData) return null;
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (decryptedData) {
      return JSON.parse(decryptedData);
    }
    return null;
  } catch (error) {
    return null;
  }
};

//.............................................Selected User Activity..........................
export const storeSelectedActivity = (data) => {
  try {
    const dataString = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    localStorage.setItem("seletedactivity", encryptedData);
  } catch (error) {}
};

export const getSelectedActivity = () => {
  try {
    const encryptedData = localStorage.getItem("seletedactivity");
    if (!encryptedData) return null;
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (decryptedData) {
      return JSON.parse(decryptedData);
    }
    return null;
  } catch (error) {
    return null;
  }
};

//.......................................Access Condition...........................

export const storeAccessCondition = (data) => {
  try {
    const dataString = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    localStorage.setItem("access", encryptedData);
  } catch (error) {}
};

export const getAccessCondition = () => {
  try {
    const encryptedData = localStorage.getItem("access");
    if (!encryptedData) return null;
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (decryptedData) {
      return JSON.parse(decryptedData);
    }
    return null;
  } catch (error) {
    return null;
  }
};
//.......................................Delete Access Condition...........................

export const storeDeleteAccess = (data) => {
  try {
    const dataString = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    localStorage.setItem("deleteAccess", encryptedData);
  } catch (error) {}
};

export const getDeleteAccess = () => {
  try {
    const encryptedData = localStorage.getItem("deleteAccess");
    if (!encryptedData) return null;
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (decryptedData) {
      return JSON.parse(decryptedData);
    }
    return null;
  } catch (error) {
    return null;
  }
};
